import { render, staticRenderFns } from "./AssignedSalesProductSidebar.vue?vue&type=template&id=79d55392&scoped=true&"
import script from "./AssignedSalesProductSidebar.vue?vue&type=script&lang=js&"
export * from "./AssignedSalesProductSidebar.vue?vue&type=script&lang=js&"
import style0 from "./AssignedSalesProductSidebar.vue?vue&type=style&index=0&id=79d55392&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d55392",
  null
  
)

export default component.exports